import React, { useRef, useState, useEffect } from "react";
import "../../../Util.css";
import { MoveLeft } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, ToastContainer, Spinner } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import { ChevronDown } from "lucide-react";
import upload from "../../../assets/Vehicles/upload_img.png";
import CommonDropdown from "../../common/common_dropDown";
import CommonStaticDropdown from "../../common/common_static_dropdown";
import SearchWithFreeText from "../../common/common_auto_freesuggestion";
import { submitWOAPI, updateWOAPI, saveAttachmentApi, getVehicleDetailsApi, getAttachmentListApi, getRemoveAttachmentApi, getWorkOrderEditApi } from "../services-api";
import ErrorExtractor from "../../common/error_extractor";
import DOMPurify from "dompurify";
import { Toast } from "bootstrap/dist/js/bootstrap.bundle.min";
import attachment from "../../../assets/png/attachment.png";
import download from "../../../assets/svg/download.svg";
import closeAttachment from "../../../assets/svg/close-red.svg";

export const WorkOrderCreate = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = location.state || {};

  const fileInputRef = useRef(null);
  const [image, setImage] = useState(null);
  const [imageSave, setImageSave] = useState(null);
  const [activeBtn, setActiveBtn] = useState("details");

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  // controller
  const [isLoader, setIsLoader] = useState(false);
  const [name, setName] = useState("");
  const [code, setcode] = useState("");
  const [vin, setvin] = useState("");
  const [licensePlate, setlicensePlate] = useState("");
  const [makeBrand, setmakeBrand] = useState("");
  const [makeYear, setmakeYear] = useState("");
  const [makeKiloMeter, setKiloMeter] = useState("");
  const [makeModel, setModel] = useState("");

  const [workOrderId, setWorkOrderId] = useState("");
  const [vinOption, setVinOption] = useState(null);
  const [vehicleName, setVehicleName] = useState("");
  const [status, setStatus] = useState("");
  const [selectedType, setSelectedType] = useState({
    label: "Service",
    value: "Service",
  });
  const [serviceOption, setServiceOption] = useState(null);
  const [issueOption, setIssueOption] = useState(null);
  const [repairPriorityOption, setRepairPriorityOption] = useState(null);
  const [issuedBy, setIssuedBy] = useState("");
  const [assignedToOption, setAssignedToOption] = useState(null);
  const [vendorOption, setVendorOption] = useState(null);
  const [startOdometer, setStartOdometer] = useState("");
  const [completeOdometer, setCompleteOdometer] = useState("");
  const [serviceTaskOption, setServiceTaskOption] = useState(null);
  const [laborOption, setLaborOption] = useState(null);
  const [description, setDescription] = useState("");

  const [issueDate, setIssueDate] = useState(new Date().toLocaleDateString("en-CA"));
  const [issueTime, setIssueTime] = useState(new Date().toTimeString().slice(0, 5));
  const [startDate, setStartDate] = useState();
  const [startTime, setStartTime] = useState();
  const [endDate, setEndDate] = useState();
  const [endTime, setEndTime] = useState();

  const [dragging, setDragging] = useState(false);
  const [attachmentURLList, setAttachmentURLList] = useState([]);
  const [attachmentList, setAttachmentList] = useState([]);
  const [removedAttachmentList, setRemovedAttachmentList] = useState([]);

  useEffect(() => {
    if (id != null) {
      getWorkOrderEdit(id);
    }
  }, [id]);

  const handleInputFile = () => {
    fileInputRef.current.click();
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      /* const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl); */
      const reader = new FileReader();
      reader.onload = async () => {
        const base64String = await reader.result; // this will be the byte code (base64String)
        /*  console.log("Base64 String:", base64String.toString());
         saveAttachment(await reader.result); */
        console.log("3..........");
        setAttachmentList([
          ...attachmentList,
          {
            name: file.name,
            base64: base64String,
            size: formatBytes(file.size),
          },
        ]);
      };
      reader.readAsDataURL(file);
    }
  };
  const formatBytes = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDragging(false);

    const file = event.dataTransfer.files[0];
    if (file) {
      /* const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl); */
      const reader = new FileReader();
      reader.onload = async () => {
        const base64String = await reader.result; // this will be the byte code (base64String)
        /*  console.log("Base64 String:", base64String.toString());
           saveAttachment(await reader.result); */
        setAttachmentList([
          ...attachmentList,
          {
            name: file.name,
            base64: base64String,
            size: formatBytes(file.size),
          },
        ]);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleDelete = () => {
    setImage(null);
    fileInputRef.current.value = "";
  };

  const handleSelectVin = (item) => {
    setVinOption(item); // store selected id
    getVehicleDetails(item.value);
  };

  const getVehicleDetails = async (id) => {
    try {
      const response = await getVehicleDetailsApi(id);
      console.log(response.data);
      if (response.data.success === true) {
        setVehicleName(response.data.vehicle?.name ?? "");
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const typeList = [
    { label: "Service", value: "Service" },
    { label: "Issue", value: "Issue" },
    { label: "Direct", value: "Direct" },
  ];

  const handleTypeSelect = (item) => {
    setSelectedType(item);
  };
  const handleSelectService = (item) => {
    setServiceOption(item);
  };
  const handleSelectIssue = (item) => {
    setIssueOption(item);
  };
  const handleSelectAssignedTo = (item) => {
    setAssignedToOption(item);
  };
  const handleSelectVendor = (item) => {
    setVendorOption(item);
  };

  const repairPriorityList = [
    { label: "High", value: "High" },
    { label: "Medium", value: "Medium" },
    { label: "Low", value: "Low" },
  ];

  const handleSelectLabor = (item) => {
    setLaborOption(item);
  };
  const handleRepairPrioritySelect = (item) => {
    setRepairPriorityOption(item); // store selected id
  };

  const [selectedFuelType, setSelectedFuelType] = useState(null);

  const handleSelectFuelType = (item) => {
    setSelectedFuelType(item); // store selected id
  };

  const fuelTypeList = [
    { label: "Petrol", value: "Petrol" },
    { label: "Diesel", value: "Diesel" },
    { label: "Gas", value: "Gas" },
    { label: "Electric", value: "Electric" },
  ];

  // trim
  const [selectedTrim, setSelectedTrim] = useState(null);
  const [searchTrim, setSearchTrim] = useState("");

  const handleDropdownTrimChange = (option) => {
    console.log("Selected option:", option);
    setSelectedTrim(option);
  };

  const handleSearchTrimChange = (value) => {
    console.log("Search input changed:", value);
    setSearchTrim(value);
  };
  const [selectedvehType, setSelectedvehType] = useState(null);
  const [searchVehType, setSearchVehType] = useState("");

  const handleDropdownVehTypeChange = (option) => {
    console.log("Selected option:", option);
    setSelectedvehType(option);
  };

  const handleSearchVehTypeChange = (value) => {
    console.log("Search input changed:", value);
    setSearchVehType(value);
  };
  // group location value

  const [errorMsg, setErrorMsg] = useState({
    title: "",
    vehicle_id: "",
    priority: "",
    assigned_to: "",
    type: "",
    reference_id: "",
    description: "",
    start_date: "",
    start_time: "",
    end_date: "",
    end_time: "",
    vendor_id: "",
    labour_id: "",
    start_meter: "",
    completion_meter: "",
    images: "",
  });

  const submitForm = async () => {
    setIsLoader(true);
    const extractor = new ErrorExtractor();
    try {
      const preSanitizeData = {
        title: name,
        vehicle_id: vinOption != null ? vinOption.value : "",
        priority: repairPriorityOption != null ? repairPriorityOption.value : "",
        assigned_to: assignedToOption != null ? assignedToOption.value : "",
        type: selectedType != null ? selectedType.value : "",
        reference_id: selectedType?.value === "Service" ? (serviceOption != null ? serviceOption.value : "") : selectedType?.value === "Issue" ? (issueOption != null ? issueOption.value : "") : "",
        description: description,
        start_date: startDate ?? "",
        start_time: startTime ?? "",
        end_date: endDate ?? "",
        end_time: endTime ?? "",
        vendor_id: vendorOption != null ? vendorOption.value : "",
        labour_id: laborOption != null ? laborOption.value : "",
        start_meter: startOdometer,
        completion_meter: completeOdometer,
        removed_images: removedAttachmentList ?? [],
        images: [],
      };
      const sanitizedData = {};
      Object.entries(preSanitizeData).forEach(([key, value]) => {
        if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value) || key === "assignee") {
          sanitizedData[key] = value;
        } else {
          sanitizedData[key] = DOMPurify.sanitize(value);
        }
      });
      var response = null;
      if (id == null) {
        response = await submitWOAPI(sanitizedData);
      } else {
        response = await updateWOAPI(id, sanitizedData);
      }

      console.log("sdddd", response);
      // Check if response indicates failure
      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = {
            title: "",
            vehicle_id: "",
            priority: "",
            assigned_to: "",
            type: "",
            reference_id: "",
            description: "",
            start_date: "",
            start_time: "",
            end_date: "",
            end_time: "",
            vendor_id: "",
            labour_id: "",
            start_meter: "",
            completion_meter: "",
            images: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setErrorMsg(validationTemp);
        });
      } else if (response.data.success === true) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
        console.log("saveAttachment called 0");
        if (attachmentList.length === 0) {
          console.log("saveAttachment called 1");
          navigate(-1);
        } else {
          console.log("saveAttachment called 2");
          saveAttachment(response.data.id);
        }
      }
    } catch (err) {
      console.error("Error submitting form:", err);

      // Optional: handle network errors separately
      if (err.response && err.response.status === 400 && err.response.data.error) {
        const errorvalue = extractor.extractErrors(err.response.data, {
          ...errorMsg,
        });
        setErrorMsg(errorvalue);
      }
    }
    setIsLoader(false);
  };
  const saveAttachment = async (workOrderId) => {
    console.log("saveAttachment called");
    try {
      const data = {
        attachment: attachmentList.map((item) => item.base64),
      };
      const response = await saveAttachmentApi(workOrderId, data);
      if (response.data.success === true) {
        navigate(-1);
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
    }
  };

  const getWorkOrderEdit = async (id) => {
    try {
      const response = await getWorkOrderEditApi(id);

      if (response.data.success === true) {
        const workOrderDetail = response.data.workorder ?? {};

        setName(workOrderDetail.title ?? "");
        setVinOption({
          value: workOrderDetail.vehicle_id ?? "",
          label: workOrderDetail.lic_no ?? "",
        });
        setVehicleName(workOrderDetail.vehicle_name ?? "");
        setRepairPriorityOption({
          value: workOrderDetail.priority ?? "",
          label: workOrderDetail.priority ?? "",
        });
        setAssignedToOption({
          value: workOrderDetail.assignee_id ?? "",
          label: workOrderDetail.assignee ?? "",
        });
        setSelectedType({
          value: workOrderDetail.type ?? "",
          label: workOrderDetail.type ?? "",
        });
        if (workOrderDetail.type === "Service") {
          setServiceOption({
            value: workOrderDetail.reference_id ?? "",
            label: workOrderDetail.reference_name ?? "",
          });
        }
        if (workOrderDetail.type === "Issue") {
          setIssueOption({
            value: workOrderDetail.reference_id ?? "",
            label: workOrderDetail.reference_name ?? "",
          });
        }
        setDescription(workOrderDetail.description);
        setStartDate(workOrderDetail.start_date);
        setStartTime(workOrderDetail.start_time);
        setEndDate(workOrderDetail.end_date);
        setEndTime(workOrderDetail.end_time);
        setVendorOption({
          value: workOrderDetail.vendor_id ?? "",
          label: workOrderDetail.vendor ?? "",
        });
        setLaborOption({
          value: workOrderDetail.labour_id ?? "",
          label: workOrderDetail.labour ?? "",
        });
        setStartOdometer(workOrderDetail.start_odometer ?? "");
        setCompleteOdometer(workOrderDetail.end_odometer ?? "");
        setAttachmentURLList(workOrderDetail.images ?? []);
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const downloadFile = (fileUrl, fileName) => {
    fetch(fileUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => console.error("Download error:", error));
  };

  return (
    <>
      <div className="">
        <div>
          <div className="px-3  bg-white d-flex align-items-center justify-content-between">
            <div className="d-flex gap-3 my-3">
              <MoveLeft className="cursor-pointer" onClick={() => navigate(-1)} />
              <p className="fw-semibold m-0">New work order</p>
            </div>
            <div className="d-flex gap-3">
              <Button className="bg-white rounded-pill px-4 py-2 pagination-color btn-border-grey" onClick={() => navigate(-1)}>
                Cancel
              </Button>
              <Button className={`d-flex justify-content-center dark-purple-btn ${isLoader ? "disabled-btn" : ""} rounded-pill py-2 px-4`} onClick={submitForm} style={{ minWidth: "100px" }}>
                {isLoader ? <Spinner animation="border" size="sm" /> : id !== null && id !== undefined ? "Update" : "Save"}
              </Button>
            </div>
          </div>

          <div className="px-2">
            <div className="bg-white p-3 my-2 rounded-4">
              <div className="d-flex flex-wrap gap-3 align-items-center justify-content-between">
                <div onClick={handleInputFile} onDrop={handleDrop} onDragOver={(e) => e.preventDefault()} onDragEnter={() => setDragging(true)} onDragLeave={() => setDragging(false)} className="d-flex align-items-center gap-3">
                  {image ? (
                    <img
                      src={image}
                      alt="Uploaded Vehicle"
                      className="rounded"
                      style={{
                        width: "60px",
                        height: "60px",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <img src={upload} alt="Upload Icon" style={{ width: "60px", height: "60px" }} />
                  )}

                  <div className="d-flex flex-column">
                    <p className="fw-semibold m-0">Upload vehicle photo</p>
                    <p className="m-0 fs-14 text-muted-grey">An image of the vehicle, it's best if it has the same length and height</p>
                  </div>
                </div>

                {image ? (
                  <Button className="bg-danger border-0 text-white rounded-pill px-4 py-2 fw-500" onClick={handleDelete}>
                    Delete
                  </Button>
                ) : (
                  <Button className="bg-transparent choose-file-border-grey text-dark-purple rounded-pill px-4 py-2 fw-500" onClick={handleInputFile}>
                    Choose from files
                  </Button>
                )}

                <input type="file" accept="image/*" ref={fileInputRef} className="d-none" onChange={handleFileChange} />
              </div>
            </div>
            {attachmentURLList.length > 0 && (
              <div
                style={{
                  marginTop: "16px",
                  marginBottom: "16px",
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "start",
                  gap: "16px",
                }}
              >
                {attachmentURLList.map((item, attachIndex) => (
                  <div
                    style={{
                      width: "312px",
                      height: "62px",
                      borderRadius: "12px",
                      padding: "12px 16px 12px 16px",
                      backgroundColor: "#FFFFFF",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img src={attachment} style={{ width: "37px", height: "36px" }} />
                    <div
                      style={{
                        width: "240px",
                        marginLeft: "8px",
                        marginTop: "4px",
                      }}
                    >
                      <span
                        style={{
                          fontFamily: "Satoshi",
                          fontWeight: "500px",
                          fontSize: "13px",
                          lineHeight: "17.55px",
                          color: "#212129",
                          marginBottom: "2px",
                        }}
                      >
                        {item.name}
                      </span>
                      <br />
                      <p
                        style={{
                          fontFamily: "Satoshi",
                          fontWeight: "400px",
                          fontSize: "12px",
                          lineHeight: "16.2px",
                          color: "#8790A1",
                        }}
                      >
                        {item.size}
                      </p>
                    </div>

                    {item.url && (
                      <div
                        onClick={() => {
                          downloadFile(item.url, item.url.split("/").pop());
                        }}
                        style={{
                          width: "32px",
                          height: "32px",
                          borderRadius: "100px",
                        }}
                      >
                        <img
                          src={download}
                          style={{
                            width: "12.8px",
                            height: "12px",
                            top: "10px",
                            left: "9.6px",
                          }}
                        />
                      </div>
                    )}

                    <div
                      style={{
                        position: "relative",
                        width: "32px",
                        height: "32px",
                        borderRadius: "100px",
                        marginLeft: "4px",
                      }}
                    >
                      <img
                        src={closeAttachment}
                        style={{
                          width: "12.8px",
                          height: "12px",
                          top: "10px",
                          left: "9.6px",
                        }}
                        alt="remove"
                        onClick={() => {
                          setRemovedAttachmentList([...removedAttachmentList, item.id]);
                          setAttachmentURLList(attachmentURLList.filter((_, i) => i !== attachIndex));
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            )}
            {attachmentList.length > 0 && (
              <div
                style={{
                  marginTop: "16px",
                  display: "flex",
                  marginBottom: "16px",
                  flexWrap: "wrap",
                  justifyContent: "start",
                  gap: "16px",
                }}
              >
                {attachmentList.map((item, attachIndex) => (
                  <div
                    style={{
                      width: "312px",
                      height: "62px",
                      borderRadius: "12px",
                      padding: "12px 16px 12px 16px",
                      backgroundColor: "#FFFFFF",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img src={attachment} style={{ width: "37px", height: "36px" }} />
                    <div
                      style={{
                        width: "210px",
                        marginLeft: "8px",
                        marginTop: "4px",
                      }}
                    >
                      <div
                        style={{
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          fontWeight: "500px",
                          fontSize: "13px",
                          lineHeight: "17.55px",
                          color: "#212129",
                          marginBottom: "2px",
                        }}
                      >
                        {item.name}
                      </div>
                      <p
                        style={{
                          fontWeight: "400px",
                          fontSize: "12px",
                          lineHeight: "16.2px",
                          color: "#8790A1",
                        }}
                      >
                        {item.size}
                      </p>
                    </div>

                    <div
                      style={{
                        position: "relative",
                        width: "32px",
                        height: "32px",
                        borderRadius: "100px",
                        marginLeft: "4px",
                      }}
                    >
                      <img
                        src={closeAttachment}
                        style={{
                          width: "12.8px",
                          height: "12px",
                          top: "10px",
                          left: "9.6px",
                        }}
                        onClick={() => {
                          setAttachmentList(attachmentList.filter((_, i) => i !== attachIndex));
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div className="d-flex flex-xl-nowrap flex-wrap gap-2">
              <div className="vehicle-info bg-white rounded-4 p-3">
                <p className="fs-18 fw-600 mb-0">Work order Details</p>
                <div className="row">
                  <div className="col-xl-6 col-12">
                    <label htmlFor="name" className="form-label  fw-400 mt-3 d-flex">
                      Name<span className="error-text">*</span>
                    </label>
                    <input type="text" className="form-control rounded-3 vehicle-form-input" id="name" value={name} placeholder="Enter here..." onChange={(e) => setName(e.target.value)} />
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                        marginTop: "6px",
                        marginLeft: "6px",
                      }}
                    >
                      {errorMsg.title}
                    </span>
                  </div>
                  <div className="col-xl-6 col-12">
                    <label htmlFor="vinOption" className="form-label  fw-400 mt-3 d-flex">
                      License Plate<span className="error-text">*</span>
                    </label>
                    <CommonDropdown apiUrl={`${apiUrl}get_vehicle`} placeholder="Select VIN" value={vinOption} onSelect={handleSelectVin} />{" "}
                    {/*  <SearchWithFreeText
                          apiUrl={`${apiUrl}get_vehicle`}
                          placeholder="Search & type..."
                          selectedValue={vinOption}
                          onDropdownChange={handleDropdownTrimChange}
                          onChangeSearch={handleSearchTrimChange}
                        />{" "} */}
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                        marginTop: "6px",
                        marginLeft: "6px",
                      }}
                    >
                      {errorMsg.vehicle_id}
                    </span>
                  </div>
                  <div className="col-xl-6 col-12">
                    <label htmlFor="license" className="form-label  fw-400 mt-3">
                      Vehicle Name
                    </label>
                    <input type="text" className="form-control rounded-3 vehicle-form-input" id="license" value={vehicleName} readOnly={true} />{" "}
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                        marginTop: "6px",
                        marginLeft: "6px",
                      }}
                    >
                      {errorMsg.lic_no}
                    </span>
                  </div>
                  <div className="col-xl-6 col-12">
                    <label htmlFor="type" className="form-label  fw-400 mt-3">
                      Type
                    </label>
                    <CommonStaticDropdown items={typeList} placeholder="Select type" value={selectedType} onSelect={handleTypeSelect} enableSearch={false} />
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                        marginTop: "6px",
                        marginLeft: "6px",
                      }}
                    >
                      {errorMsg.type}
                    </span>
                  </div>
                  {selectedType?.value === "Service" && (
                    <div className="col-xl-6 col-12">
                      <label htmlFor="vinOption" className="form-label  fw-400 mt-3">
                        Service
                      </label>
                      <CommonDropdown apiUrl={`${apiUrl}get_services`} placeholder="Select Services" value={serviceOption} onSelect={handleSelectService} />{" "}
                      {/*  <SearchWithFreeText
                          apiUrl={`${apiUrl}get_vehicle`}
                          placeholder="Search & type..."
                          selectedValue={vinOption}
                          onDropdownChange={handleDropdownTrimChange}
                          onChangeSearch={handleSearchTrimChange}
                        />{" "} */}
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                          marginTop: "6px",
                          marginLeft: "6px",
                        }}
                      >
                        {errorMsg.reference_id}
                      </span>
                    </div>
                  )}
                  {selectedType?.value === "Issue" && (
                    <div className="col-xl-6 col-12">
                      <label htmlFor="vinOption" className="form-label  fw-400 mt-3">
                        Issue
                      </label>
                      <CommonDropdown apiUrl={`${apiUrl}get_issues`} placeholder="Select Issue" value={issueOption} onSelect={handleSelectIssue} />{" "}
                      {/*  <SearchWithFreeText
                          apiUrl={`${apiUrl}get_vehicle`}
                          placeholder="Search & type..."
                          selectedValue={vinOption}
                          onDropdownChange={handleDropdownTrimChange}
                          onChangeSearch={handleSearchTrimChange}
                        />{" "} */}
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                          marginTop: "6px",
                          marginLeft: "6px",
                        }}
                      >
                        {errorMsg.reference_id}
                      </span>
                    </div>
                  )}
                  <div className="col-xl-6 col-12">
                    <label htmlFor="vinOption" className="form-label  fw-400 mt-3 d-flex">
                      Assigned To<span className="error-text">*</span>
                    </label>
                    <CommonDropdown apiUrl={`${apiUrl}get_users`} placeholder="Select Assigned To" value={assignedToOption} onSelect={handleSelectAssignedTo} />{" "}
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                        marginTop: "6px",
                        marginLeft: "6px",
                      }}
                    >
                      {errorMsg.assigned_to}
                    </span>
                  </div>
                  <div className="col-xl-6 col-12">
                    <label htmlFor="vinOption" className="form-label  fw-400 mt-3">
                      Vendor
                    </label>
                    <CommonDropdown apiUrl={`${apiUrl}get_vendors`} placeholder="Select Vendor" value={vendorOption} onSelect={handleSelectVendor} />{" "}
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                        marginTop: "6px",
                        marginLeft: "6px",
                      }}
                    >
                      {errorMsg.vendor_id}
                    </span>
                  </div>
                  <div className="col-xl-6 col-12">
                    <label htmlFor="StartOdometer" className="form-label  fw-400 mt-3">
                      Start Odometer
                    </label>
                    <input
                      type="text"
                      className="form-control rounded-3 vehicle-form-input"
                      id="StartOdometer"
                      value={startOdometer}
                      placeholder="Enter here..."
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        setStartOdometer(value);
                      }}
                    />
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                        marginTop: "6px",
                        marginLeft: "6px",
                      }}
                    >
                      {errorMsg.start_meter}
                    </span>
                  </div>

                  <div className="col-xl-6 col-12">
                    <label htmlFor="completeOdometer" className="form-label  fw-400 mt-3">
                      Complete Odometer
                    </label>
                    <input
                      type="text"
                      className="form-control rounded-3 vehicle-form-input"
                      id="completeOdometer"
                      value={completeOdometer}
                      placeholder="Enter here..."
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        setCompleteOdometer(value);
                      }}
                    />
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                        marginTop: "6px",
                        marginLeft: "6px",
                      }}
                    >
                      {errorMsg.completion_meter}
                    </span>
                  </div>
                  <div className="col-xl-6 col-12">
                    <label htmlFor="RepairPriorityClass" className="form-label  fw-400 mt-3 d-flex">
                      Repair Priority Class
                      <span className="error-text">*</span>
                    </label>
                    <CommonStaticDropdown items={repairPriorityList} placeholder="Select repair priority" value={repairPriorityOption} onSelect={handleRepairPrioritySelect} enableSearch={false} />
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                        marginTop: "6px",
                        marginLeft: "6px",
                      }}
                    >
                      {errorMsg.priority}
                    </span>
                  </div>
                  <div className="col-xl-6 col-12">
                    <label htmlFor="Labor" className="form-label  fw-400 mt-3">
                      Labor
                    </label>
                    <CommonDropdown apiUrl={`${apiUrl}get_labours`} placeholder="Select Labor" value={laborOption} onSelect={handleSelectLabor} />{" "}
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                        marginTop: "6px",
                        marginLeft: "6px",
                      }}
                    >
                      {errorMsg.labour_id}
                    </span>
                  </div>
                  <div className="col-12">
                    <label htmlFor="Description" className="form-label  fw-400 mt-3 d-flex">
                      Description<span className="error-text">*</span>
                    </label>
                    <textarea type="text" className="form-control rounded-3 vehicle-form-input" id="Description" value={description} placeholder="Enter here..." onChange={(e) => setDescription(e.target.value)} rows={3} />
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                        marginTop: "6px",
                        marginLeft: "6px",
                      }}
                    >
                      {errorMsg.description}
                    </span>
                  </div>
                </div>
              </div>
              <div className="vehicle-classi bg-white rounded-4 p-3">
                <p className="fs-18 fw-600 mb-0">Date & Timing details</p>
                <div className="row">
                  <div className="col-xl-6 col-12">
                    <label htmlFor="issueDate" className="form-label  fw-400 ">
                      Issued date
                    </label>
                    <input
                      type="date"
                      className="form-control rounded-3 vehicle-form-input"
                      id="issueDate"
                      value={issueDate}
                      placeholder="Select here..."
                      onChange={(e) => {
                        setIssueDate(e.target.value);
                      }}
                    />
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                        marginTop: "6px",
                        marginLeft: "6px",
                      }}
                    >
                      {errorMsg.name}
                    </span>
                  </div>
                  <div className="col-xl-6 col-12">
                    <label htmlFor="issueTime" className="form-label  fw-400 ">
                      Issued time
                    </label>
                    <input
                      type="time"
                      className="form-control rounded-3 vehicle-form-input"
                      id="issueTime"
                      value={issueTime}
                      placeholder="Select here..."
                      onChange={(e) => {
                        setIssueTime(e.target.value);
                      }}
                    />
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                        marginTop: "6px",
                        marginLeft: "6px",
                      }}
                    >
                      {errorMsg.name}
                    </span>
                  </div>

                  <div className="col-xl-6 col-12">
                    <label htmlFor="startDate" className="form-label  fw-400 mt-3">
                      Start date
                    </label>
                    <input
                      type="date"
                      className="form-control rounded-3 vehicle-form-input"
                      id="startDate"
                      value={startDate}
                      placeholder="Select here..."
                      onChange={(e) => {
                        setStartDate(e.target.value);
                      }}
                    />
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                        marginTop: "6px",
                        marginLeft: "6px",
                      }}
                    >
                      {errorMsg.name}
                    </span>
                  </div>
                  <div className="col-xl-6 col-12">
                    <label htmlFor="startTime" className="form-label  fw-400 mt-3">
                      Start time
                    </label>
                    <input
                      type="time"
                      className="form-control rounded-3 vehicle-form-input"
                      id="startTime"
                      value={startTime}
                      placeholder="Select here..."
                      onChange={(e) => {
                        console.log(e.target.value);
                        setStartTime(e.target.value);
                      }}
                    />
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                        marginTop: "6px",
                        marginLeft: "6px",
                      }}
                    >
                      {errorMsg.name}
                    </span>
                  </div>

                  <div className="col-xl-6 col-12">
                    <label htmlFor="endDate" className="form-label  fw-400 mt-3">
                      End date
                    </label>
                    <input
                      type="date"
                      className="form-control rounded-3 vehicle-form-input"
                      id="endDate"
                      value={endDate}
                      min={startDate}
                      placeholder="Select here..."
                      onChange={(e) => {
                        setEndDate(e.target.value);
                      }}
                    />
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                        marginTop: "6px",
                        marginLeft: "6px",
                      }}
                    >
                      {errorMsg.name}
                    </span>
                  </div>
                  <div className="col-xl-6 col-12">
                    <label htmlFor="endTime" className="form-label  fw-400 mt-3">
                      End time
                    </label>
                    <input
                      type="time"
                      className="form-control rounded-3 vehicle-form-input"
                      id="endTime"
                      value={endTime}
                      min={startTime}
                      placeholder="Select here..."
                      onChange={(e) => {
                        setEndTime(e.target.value);
                      }}
                    />
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                        marginTop: "6px",
                        marginLeft: "6px",
                      }}
                    >
                      {errorMsg.name}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>{" "}
    </>
  );
};
